<header
  class="sticky top-0 z-30 flex h-[72px] items-center gap-4 border-b border-brand-100 bg-white/70 px-5 backdrop-blur-xl lg:px-8"
>
  <!-- Marca -->
  <a [routerLink]="'/dashboard'" class="flex shrink-0 items-center gap-3">
    <span class="flex h-9 w-9 items-center justify-center rounded-xl bg-lime-500 text-lg font-extrabold text-lime-ink">í</span>
    <div class="hidden leading-tight sm:block">
      <p class="font-display text-theme-sm font-extrabold tracking-tight text-brand-950">ísimo</p>
      <p class="text-theme-xs text-gray-400">Panel LIQUITECH</p>
    </div>
  </a>

  <!-- Búsqueda (Tailwind puro) -->
  <div class="relative hidden w-full max-w-xs lg:block">
    <span class="pointer-events-none absolute left-3.5 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400">
      <app-icon name="search" />
    </span>
    <input
      type="search"
      placeholder="Buscar factura, cesión, proveedor…"
      class="h-11 w-full rounded-full border border-brand-100 bg-white/60 pl-10 pr-4 font-ui text-theme-sm text-gray-700 transition placeholder:text-gray-400 focus:border-brand-300 focus:bg-white focus:outline-none focus:ring-4 focus:ring-brand-500/10"
    />
  </div>

  <div class="ml-auto flex items-center gap-3">
    <!-- Selector de rol (Góndola) -->
    <div class="hidden items-center gap-1 rounded-full border border-brand-100 bg-brand-50 p-1 sm:flex">
      @for (rol of roles; track rol) {
        <button
          type="button"
          (click)="setRol(rol)"
          class="rounded-full px-3.5 py-1.5 font-ui text-theme-xs font-bold transition"
          [class]="
            auth.rolVista() === rol
              ? 'bg-brand-500 text-white shadow-theme-sm'
              : 'text-gray-500 hover:text-brand-600'
          "
        >
          {{ rolLabel[rol] }}
        </button>
      }
    </div>

    <!-- Filtro de factor (multi-factor) -->
    <div class="hidden w-52 lg:block">
      <p-select
        [formControl]="factorCtrl"
        [options]="opcionesFactor()"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        placeholder="Factor"
      />
    </div>

  </div>
</header>
